module.exports = __webpack_public_path__ + "img/thumbnail.d0d03961.svg";